'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var createHtmlRenderState = function () {
  return {
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {}
  };
};

exports.createHtmlRenderState = createHtmlRenderState;
